import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type TJsonQuery, term, terms } from '@/packages/JsonQuery';
import { type SortType } from '@/packages/api-models/common/json_query';

export type JsonQueryInitialState = {
  filters: TJsonQuery;
  page: number;
  sort: SortType;
};

const jsonQueryInitialState: JsonQueryInitialState = {
  filters: { _type: 'flatsale', engine_version: term(2), region: terms([1]) },
  page: 1,
  sort: 'default',
};

export const { reducer: jsonQueryReducer, actions: jsonQueryActions } = createSlice({
  initialState: { ...jsonQueryInitialState },
  name: 'jsonQuery',
  reducers: {
    setFilters(state, action: PayloadAction<TJsonQuery>) {
      state.filters = action.payload;
    },
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setSort(state, action: PayloadAction<SortType>) {
      state.sort = action.payload;
    },
    setSortWithPageReset(state, action: PayloadAction<SortType>) {
      state.sort = action.payload;
      state.page = jsonQueryInitialState.page;
    },
  },
});
